<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <upload
            @updatedSrc="getSrc"
            :preview="tile"
            @updateTitle="getName"
          ></upload>
        </v-col>

        <v-col cols="12">
          <v-tabs dark>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">En</v-tab>
            <v-tab href="#tab-2">Fr</v-tab>
            <v-tab href="#tab-3">Ar</v-tab>

            <v-tab-item value="tab-1">
              <v-text-field
                class="mt-5"
                label="Title"
                v-model.trim="tile.title_en"
                type="text"
                placeholder="Tile"
                id="title_en"
              ></v-text-field>
              <v-textarea
                label="Description"
                v-model.trim="tile.description_en"
                type="text"
                placeholder="Description"
                id="description_en"
              ></v-textarea>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <v-text-field
              class="mt-5"
                label="Titre"
                v-model.trim="tile.title_fr"
                type="text"
                placeholder="Titre"
                id="title_fr"
              ></v-text-field>
              <v-textarea
                label="Description"
                v-model.trim="tile.description_fr"
                type="text"
                placeholder="La description"
                id="description_fr"
              ></v-textarea>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-text-field
              class="mt-5"
                label="عنوان"
                v-model.trim="tile.title_ar"
                type="text"
                placeholder="عنوان"
                id="title_ar"
              ></v-text-field>
              <v-textarea
                label="وصف"
                v-model.trim="tile.description_ar"
                type="text"
                placeholder="وصف"
                id="description_ar"
              ></v-textarea>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import { Upload } from "@/components/functionality";

export default {
  name: "AdminTileUpload",
  components: { Upload },
  data() {
    return {
      isValid: true,
    };
  },
  props: {
    tile: Object,
  },
  methods: {
    getSrc(val) {
      this.tile.src = val;
    },
    getName(val) {
      this.tile.title = val;
      this.$nextTick(() => {
        this.tile.title = val;
      });
    },
    validateImage(val) {
      this.isValidImage = val;
    },
  },
};
</script>
